const reduceModalAnimation = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function fadeOpacity(element, keyframes, { duration, easing = "ease" }) {
  element.getAnimations?.().forEach((a) => {
    if (a.effect?.target === element) {
      a.cancel();
    }
  });
  
  return element.animate(keyframes, { duration, easing, fill: "forwards" });
}


const DialogElement = customElements.get("dialog-element");

class Modal extends DialogElement {
  get shouldLock() {
    return true;
  }

  get shouldAppendToBody() {
    return true;
  }

  get initialFocus() {
    return this.querySelector("[data-modal-panel]") || this;
  }

  connectedCallback() {
    super.connectedCallback();

    if (!this.hasAttribute("aria-modal")) {
      this.setAttribute("aria-modal", "true");
    }

    this.querySelector("[data-modal-backdrop]")?.addEventListener(
      "click",
      () => this.hide(),
      { signal: this._abortController.signal }
    );
  }

  _showTransition(animate19 = true) {
    if (reduceModalAnimation || !animate19) {
      return Promise.resolve();
    }

    this.style.setProperty("opacity", "0");
    const anim = fadeOpacity(
      this,
      { opacity: [0, 1] },
      { duration: 220, easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)" }
    );
    return anim.finished.then(() => {
      this.style.removeProperty("opacity");
    });
  }

  _hideTransition() {
    if (reduceModalAnimation) {
      return Promise.resolve();
    }

    this.style.setProperty("visibility", "visible");
    this.style.setProperty("opacity", "1");

    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        const anim = fadeOpacity(
          this,
          { opacity: [1, 0] },
          { duration: 180, easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)" }
        );
        anim.finished.then(() => {
          this.style.removeProperty("opacity");
          this.style.removeProperty("visibility");
          resolve();
        });
      });
    });
  }
}

customElements.define("x-modal", Modal);
// Klaviyo - Added to Cart Tracking
document.addEventListener('cart:refresh', function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(function(cart) {
      if (!cart.items || cart.items.length === 0) return;

      var lastItem = cart.items[0]; // most recently added item is first
      var _learnq = window._learnq || [];

      _learnq.push(['track', 'Added to Cart', {
        '$value': cart.total_price / 100,
        'AddedItemProductName': lastItem.product_title,
        'AddedItemProductID': lastItem.product_id,
        'AddedItemSKU': lastItem.sku,
        'AddedItemCategories': [lastItem.product_type],
        'AddedItemImageURL': 'https:' + lastItem.image,
        'AddedItemURL': window.location.origin + lastItem.url,
        'AddedItemPrice': lastItem.price / 100,
        'AddedItemQuantity': lastItem.quantity,
        'ItemNames': cart.items.map(function(i) { return i.product_title; }),
        'CheckoutURL': window.location.origin + '/checkout',
        'Items': cart.items.map(function(i) {
          return {
            'ProductID': i.product_id,
            'SKU': i.sku,
            'ProductName': i.product_title,
            'Quantity': i.quantity,
            'ItemPrice': i.price / 100,
            'RowTotal': (i.price * i.quantity) / 100,
            'ProductURL': window.location.origin + i.url,
            'ImageURL': 'https:' + i.image
          };
        })
      }]);
    });
});
